export function createColors(from, to, shades, alpha = [1, 1]) {
    const rgba = [];
    const start = [...from];
    const diff = [
        to[0] - from[0],
        to[1] - from[1],
        to[2] - from[2]
    ];
    start.push(alpha[0]);
    diff.push(alpha[1] - alpha[0]);
    const inc = 1 /
        Math.max(shades - 1, 1);
    for (let i = 0; i < shades; i++) {
        const color = [
            Math.round(start[0] + i * diff[0] * inc),
            Math.round(start[1] + i * diff[1] * inc),
            Math.round(start[2] + i * diff[2] * inc),
            start[3] + i * diff[3] * inc
        ];
        rgba.push(color);
    }
    return rgba;
}
//# sourceMappingURL=createColors.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/color-map/dist-es2015/createColors.js
// module id = 664
// module chunks = 0